/**
 * Mappa dei transactionErrorCode Sella/Axerve → chiavi stabili di errore.
 * La chiave viene tradotta in messaggio utente dal client (i18n) e usata nei
 * log operatore. Codici osservati sul campo o documentati; tutto il resto
 * ricade su GENERIC.
 */
export type SellaErrorKey =
  | 'SCA_REQUIRED'    // l'issuer richiede l'autenticazione del titolare (soft decline)
  | 'DECLINED'        // transazione rifiutata dall'issuer
  | 'EXPIRED_CARD'
  | 'TECHNICAL'       // errore tecnico/configurazione lato PSP
  | 'GENERIC';

const MAP: Record<string, SellaErrorKey> = {
  '8026': 'SCA_REQUIRED',   // Soft decline - richiesta autenticazione titolare
  '8006': 'SCA_REQUIRED',   // 3DS richiesto
  '405': 'DECLINED',        // Negato dall'emittente
  '208': 'EXPIRED_CARD',    // Carta scaduta
  '2009': 'TECHNICAL',      // Campo importo non valorizzato (config M.O.T.O.)
  '8008': 'TECHNICAL',      // Funzione non disponibile sul profilo
  '1105': 'TECHNICAL',      // Parametro non valido
};

export function sellaErrorKey(code?: string | null): SellaErrorKey {
  if (!code || code === '0') return 'GENERIC';
  return MAP[code] ?? 'GENERIC';
}
